export interface Tenet {
  title: string;
  text: React.ReactNode;
}

const Tenets: Tenet[] = [
  {
    title:
      "Data Science should be done as close to business operators as possible.",
    text: (
      <>
        <p className="mb-6">
          Data Scientists and Businesses speak{" "}
          <span className="italic font-bold text-gray-700">
            different languages
          </span>{" "}
          - translating takes up too much time. Translating loses too much
          information too. Value is maximized only when business users are
          enabled to do data science themselves.
        </p>
        <p>
          Any product that intends to bridge the gap must speak the business
          language to the users.
        </p>
      </>
    ),
  },
  {
    title:
      "Business problems need explainability (why, how) as much as accuracy.",
    text: (
      <>
        <p className="mb-6">
          Business problems always need{" "}
          <span className="italic font-bold text-gray-700">actionability</span>.
          This only comes from the ability to explain and justify any
          predictions being made or inferences being drawn.
        </p>
        <p>
          Products aimed at business problems must, therefore, only use
          algorithms which lend themselves well to explainability and
          actionability.
        </p>
      </>
    ),
  },
  {
    title:
      "Its actions that are the end-point of the analysis, not inferences.",
    text: (
      <>
        <p className="mb-6">
          People who do actions are different from those that do analysis. The
          tools for actions (e.g., SalesForce, SCADA, ZenDesk) are different
          too.
        </p>
        <p>
          Hence, for maximal value addition, the product must be easy to
          integrate with other tools too.
        </p>
      </>
    ),
  },
  {
    title: "DRY: Dont Repeat Yourself",
    text: (
      <>
        <p className="mb-6">
          More than 80% of a data scientist's work is either grunt-work, or
          repititive work. Doing all that manually kills productivity.
        </p>
        <p>
          The product must support as much automation as possible, while
          retaining the flexibility to mix-and-match components as required.
        </p>
      </>
    ),
  },
];

export default Tenets;
